









import { Component, Vue, Prop } from 'vue-property-decorator'
import SequentCaller from '@/utils/SequentCaller'

@Component
export default class CaptchaInput extends Vue {
  @Prop({ required: true }) captchaImageUrl!: string
  @Prop() value!: string
  @Prop({ required: true }) captchaChecker!: Function // 接收验证码参数, 返回 promise

  public captchaIsCorrect: boolean = false

  private noCacheCaptchaImageUrl: string = ''

  private sequentChecker!: SequentCaller

  get captchaInput () {
    return this.value
  }

  set captchaInput (value: string) {
    this.$emit('input', value)
  }

  /**
   * 更新验证码图片
   */
  public updateCaptchaImg () {
    this.noCacheCaptchaImageUrl = `${this.captchaImageUrl}?nocache=${Date.now()}`
    this.captchaIsCorrect = false
  }

  /**
   * 检查验证码是否正确
   */
  private async checkCaptcha () {
    await this.$nextTick() // Firefox 要加上这个, 否则获取的结果是上一次输入的, chrome safari 正常
    await this.sequentChecker.start(null, this.value)
  }

  mounted () {
    this.updateCaptchaImg()
    this.sequentChecker = new SequentCaller(this.captchaChecker, (result: boolean) => {
      this.captchaIsCorrect = result
    })
  }
}
